import React from 'react';
import styled from 'styled-components';

const Main = styled.div`
position: absolute;
top: 0;
left: 0;
bottom: 0;
right: 0;
z-index: 999999;
display: flex;
align-items: center;
justify-content: center;
background-color: #00000069;
`;

const DialogContainer = styled.div`
width: 645px;
padding: 5px;
background-color: var(--botc-colour-cream-stark-white);
`;

const InnerContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
height: 100%;
padding: 48px 120px 32px;
border: 1px solid var(--botc-colour-cream-straw);
`;

const Title = styled.h2`
font-family: 'Dumbledor';
font-size: 32px;
text-transform: uppercase;
color: var(--botc-colour-ink-wineberry);
margin: 0;
`;

const TitleUnderline = styled.hr`
border: none;
border-top: 1px solid var(--botc-colour-cream-straw);
height: 1px;
width: 180px;
`;

const Body = styled.p`
font-family: 'Trade Gothic LT Std';
color: var(--botc-colour-ink-wineberry);
`;

const Button = styled.button`
color: var(--botc-colour-ink-wineberry);
background-color: transparent;
border: 2px solid #BDA89A;
text-align: center;
font-family: 'Trade Gothic LT Std';
font-size: 14px;
letter-spacing: 1.4px;
text-transform: uppercase;
padding: 15px 50px;
margin-top: 24px;
`;

function Component({ title, onConfirmation, children, isShown }) {
  if (!isShown) return null;
  
  return (
    <Main>
      <DialogContainer>
        <InnerContainer>
          <Title>{title}</Title>
          <TitleUnderline />
          <Body>{children}</Body>
          <Button onClick={onConfirmation} type="button">Ok</Button>
        </InnerContainer>
      </DialogContainer>
    </Main>
  )
}

export default Component;